// extracted by mini-css-extract-plugin
var _1 = "CommentActivityItem-module__commentContext--BeWOC";
var _2 = "CommentActivityItem-module__commentContextInner--S0txE";
var _3 = "CommentActivityItem-module__commentIcon--A7OYo";
var _4 = "CommentActivityItem-module__isCommentQuote--yzrw8";
var _5 = "CommentActivityItem-module__mention--dd3E0";
var _6 = "CommentActivityItem-module__resolveIcon--RrQ2j";
export { _1 as "commentContext", _2 as "commentContextInner", _3 as "commentIcon", _4 as "isCommentQuote", _5 as "mention", _6 as "resolveIcon" }
